import axios from "axios";
import { Constants } from "../constants";
import { hasCookie, getCookie, deleteAllCookies, CookieNames } from "../helpers/cookie.helper";
import store from "../store/store";
import { logout } from "./login.service";

const instance = axios.create({
    baseURL: Constants.BACKEND_URL
});

instance.interceptors.request.use(
    function (config) {
        if (hasCookie(CookieNames.AUTH_TOKEN)) {
            let storageToken = getCookie(CookieNames.AUTH_TOKEN);
            config.headers["Authorization"] = `Bearer ${storageToken}`;
        }

        // Get CompanyId from cookie or Redux state
        let companyId = 0;

        // Add CompanyId based on request method
        const method = config.method?.toLowerCase();

        // For GET and DELETE requests, add as query parameter
        config.params = config.params || {};
        config.params.CompanyId = config.params.CompanyId || companyId;

        if (method === 'post' || method === 'put' || method === 'patch') {
            // For POST, PUT, PATCH requests, add to body
            if (config.data instanceof FormData) {
                // If body is FormData, append CompanyId
                config.data.append('CompanyId', companyId);
            } else if (config.data && typeof config.data === 'object') {
                // If body is JSON object, add CompanyId to the object
                config.data = {
                    ...config.data,
                    ...(Object.keys(config?.data)?.map(el => el?.toLowerCase()).includes('companyid') ? {} : { CompanyId: companyId }),
                };
            } else if (Array.isArray(config.data)) {
                config.data = config.data.map(item => ({
                    ...item,
                    companyId: item?.companyId ?? companyId,
                    CompanyId: item?.CompanyId ?? companyId
                }));
            }
        }

        // Set Content-Type based on data type
        if (config.data instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);

instance.interceptors.response.use(
    function (response) {
        // If the user is logged out, clear local storage and redirect
        if (response.data.status === 401 && response.data.message === "User Log out") {
            console.log("User Log out--> Function triggered from 1", response);
            deleteAllCookies();
            window.location.href = "/";  // Use window.location for redirection
        }
        return response;
    },
    async function (error) {
        // If unauthorized error, perform logout and redirect
        if (error.response?.status === 401 && error.response.data === "") {
            try {
                const email = localStorage.getItem('email');
                await logout(email);
            } catch (e) {
                console.log("Error in logout", e);
            }
            deleteAllCookies();
            window.location.href = "/";  // Use window.location for redirection
        }
        return Promise.reject(error);
    }
);

export default instance;
